<template>
  <div>
    <button type="button" class="btn btn-sm btn-secondary" @click="showModalAgregarFactura"
      v-if="current.estado == 'A'">
      <i class="fa fa-plus"></i>
      Agregar pago
    </button>

    <div aria-hidden="true" class="modal fade" id="modalAgregarFactura" role="dialog" tabindex="-1">
      <div class="modal-dialog modal-xl" role="document" style="max-width: 100%;">
        <div class="modal-content modal-xl" style="max-width: 100%;">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Facturas con Saldo</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-4">
                <div class="text-center">
                  <h6 class="text-center text-dark">Total de Saldo de Cliente</h6>
                  <div v-if="current.saldo_pendiente">
                    <h4 class="text-danger">{{ formatDecimalCurrency(current.saldo_pendiente) }}</h4>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="text-center">
                  <h6 class="text-center text-dark">Total Facturas a Pagar</h6>
                  <div>
                    <h4 class="text-success">{{ formatDecimalCurrency(current.total_facturas) }}</h4>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div>
                  <h6 class="text-center text-dark">Total Pagado Agregado</h6>
                  <div>
                    <h4 class="text-center text-success">{{ formatDecimalCurrency(current.total_pagado) }}</h4>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div>
                  Buscar por:
                  <input
                    id="nitSearch"
                    type="checkbox"
                    v-model="nitSearch"
                  />
                  <label class="label-search ml-2" for="nitSearch">
                    NIT({{ current.cliente.nit }})
                  </label>
                  
                  <input
                    id="codSuperClienteSearch"
                    type="checkbox"
                    v-model="codSuperClienteSearch"
                    v-if="current.super_cliente"
                  />
                  <label class="label-search ml-2" v-if="current.super_cliente" for="codSuperClienteSearch">
                     SuperCliente({{ current.super_cliente }})
                  </label>
                  <button class="btn btn-outline-secondary" @click="refreshFacturasConSaldo(current.cliente.nit)">Buscar</button>
                </div>

                <small>
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                  En el caso no se seleccione ninguno se tomará por defecto el nit
                </small>
              </div>
              <div class="col-6">
                <input
                  class="search-input"
                  type="text"
                  v-model="searchText"
                  placeholder="Buscar por documento, nit, nombre, dirección, codigo..."
                  
                />
              </div>
              <div class="col-12">
                <div class="table-responsive">
                  <div class="table-responsive tableFixHead">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th style="width: 8%">Nit</th>
                          <th>Nombre</th>
                          <th>Dirección</th>
                          <th>Código Súper Cliente</th>
                          <th>Documento</th>
                          <th style="width: 10%">Fecha</th>
                          <th class="text-right">cargos</th>
                          <th class="text-right">abonos</th>
                          <th class="text-right">Saldo</th>
                          <th class="text-right">Acumulado</th>
                          <th class="text-right"></th>
                        </tr>
                      </thead>
                      <tbody style="max-height: 400px;">
                        <tr v-for="item in cargosFiltrados" :key="item.id">
                          <td>{{ item.cliente_id }}</td>
                          <td>{{ item.cliente_nombre }}</td>
                          <td>{{ item.cliente_direccion }}</td>
                          <td>{{ item.cod_super_cliente }}</td>
                          <td>{{ item.numero_fel }}</td>
                          <td>{{ item.fecha }}</td>
                          <td class="text-right">{{ item.cargos }}</td>
                          <td class="text-right">{{ item.abonos }}</td>
                          <td class="text-right">{{ item.saldo }}</td>
                          <td class="text-right"></td>
                          <td class="text-right">
                            <button @click="agregarFactura(item)" type="button"
                              class="btn btn-secondary btn-sm">Agregar</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-------------------- END - Basic Table -------------------->
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" ref="cerrarModal" data-dismiss="modal" type="button">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import _ from "lodash";
import Notifications from "@/notifications/notifications";
import ClientesSelectComponent from "@/components/commons/ClientesSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    ClientesSelectComponent,
    TiendaSelectComponent,
  },
  props: {
    current: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      _current: {},
      caja: "",
      facturas_con_saldo: [],
      searchText:"",
      searchTimeout: null,
      nitSearch: false,
      codSuperClienteSearch: false,
    };
  },
  computed: {
    cargosFiltrados() {
      // Si el campo de búsqueda está vacío, muestra todas las facturas
      if (!this.searchText) {
        return this.facturas_con_saldo;
      }
      const lowerCaseSearch = this.searchText.toLowerCase();
      return this.facturas_con_saldo.filter(factura => {
        //Convertir en String los campos a filtrar
        const numFel = String(factura.numero_fel || "");
        const nombreCliente = String(factura.cliente_nombre || "");
        const nitCliente = String(factura.cliente_id || "");
        const direccionCliente = String(factura.cliente_direccion || "");
        const codigoSuperCliente = String(factura.cod_super_cliente || "");
        // Convierte en minúsculas y realiza la búsqueda en el caso la cadena incluya alguno de los caracteres escritos en el campo de busqueda
        return (
          numFel.toLowerCase().includes(lowerCaseSearch) ||
          nombreCliente.toLowerCase().includes(lowerCaseSearch) ||
          nitCliente.toLowerCase().includes(lowerCaseSearch) ||
          direccionCliente.toLowerCase().includes(lowerCaseSearch) ||
          codigoSuperCliente.toLowerCase().includes(lowerCaseSearch)
        );
      });
    },
  },
  mounted() { },
  methods: {
    formatDecimalCurrency(valor) {
      return 'Q ' + valor.toLocaleString('es-GT', { maximumFractionDigits: 2, minimumFractionDigits: 2 })
    },
    showModalAgregarFactura() {
      let self = this;
      self.refreshFacturasConSaldo(self.current.cliente.nit);
      $("#modalAgregarFactura").modal();
    },
    refreshFacturasConSaldo(nit_cliente) {
      let self = this;
      if (!nit_cliente) {
        return;
      }
      self.facturas_con_saldo = [];
      let params = { tienda: self.current.tienda.codigo }

      if(self.nitSearch) {params.nit = self.current.cliente.nit; }
      if(self.codSuperClienteSearch) { params.super_cliente = self.current.super_cliente; }
      if(!self.nitSearch && !self.codSuperClienteSearch){ params.nit = self.current.cliente.nit;}

      DynamicService.getAction(
        "cat",
        "clientes",
        nit_cliente,
        "cargos_pendientes",
        params
      )
        .then((response) => {
          console.log("datos:",response.data);
          self.facturas_con_saldo = response.data;
        })
        .catch((err) => { });
    },
    agregarFactura(factura) {
      let self = this;
      DynamicService.postAction(
        "cxc",
        "cobros",
        self.current.id,
        "agregar_factura",
        {
          cargo_e: factura.id
        }
      ).then((response) => {
        {
          Notifications.alert.success(
            "Adición de Factura al Cobro",
            "¡se ha realizado exitosamente!"
          );
          $("#modalAddDetailReqCompra").modal("hide");
          self.$emit("refreshData");
        }
      }).catch((error) => {
        self.current.errors = error.response.data;
        Notifications.alert.error(
          "Adición de Factura",
          self.current.errors.cargo_e
        )
      });;
    },
    cerrandoModal() {
      this.$emit("cerrandomodal");
    },
  },
};
</script>
<style scoped>

.label-search{
  margin-right: 15px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.search-input{
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
}
</style>